import { gql } from 'apollo-angular';

export const productFragment = gql`
fragment product on Product {
  _id
  lang
  name
  images
  slug
  views
  updatedAt
  rank
  shortDescription
  productStatus
  companySlug
  video {
    public_id
    aspect_ratio
  }
  categories (lang: $lang) {
    refName
    refPath
    path
  }
}
`;



